import { render, staticRenderFns } from "./EventFormat.vue?vue&type=template&id=6f0c5f32&"
import script from "./EventFormat.vue?vue&type=script&lang=js&"
export * from "./EventFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports